<template>
  <v-layout column>
    <v-row>
      <v-col cols="12">
        <UtmTable
          :dates="dates"
          :selected-domains="selectedDomains"
          :status="status"
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import UtmTable from "@/components/Analytics/Campaigns/UtmTable";
import domainsAndDateSelection from "@/core/mixins/domainsAndDateSelection.mixin";

export default {
  name: "Campaigns",
  components: {
    UtmTable
  },
  mixins: [domainsAndDateSelection],
  data() {
    return {
      status: true
    };
  },
  methods: {
    switchBlockedStatus() {
      if (this.status) {
        return "Blocked";
      }

      return "Not blocked";
    }
  }
};
</script>
